import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    position: 'relative',
    width: '-webkit-fill-available',
    height: '-webkit-fill-available',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
  },
  tabWrapper: {
    all: 'unset',
    flexDirection: 'row',
    flex: 1,
  },
  tabContent: {
    width: '100%',
    backgroundColor: theme.palette.neutralWhite,
    paddingLeft: pxToRem(23),
  },
  tabLabelLarge: {
    fontSize: pxToRem(10),
    fontWeight: 600,
    color: theme.palette.neutralDark,
    paddingTop: pxToRem(2),
  },

  tabLabelSmall: {
    fontSize: pxToRem(16),
    padding: `${pxToRem(12)} 0 ${pxToRem(14)} ${pxToRem(16)}`,
  },
  tabSummaryLarge: {
    fontSize: pxToRem(22),
    fontWeight: 300,
    color: theme.palette.neutralDark,
    display: 'block',
  },
  tabSummarySmall: {
    fontSize: pxToRem(16),
    padding: `${pxToRem(12)} ${pxToRem(16)} ${pxToRem(14)} 0`,
  },
  cardWrapperLarge: {
    boxShadow: 'none',
    textAlign: 'left',
    height: '-webkit-fill-available',
    width: '-webkit-fill-available',
    paddingTop: pxToRem(0),
    paddingBottom: pxToRem(0),
  },
  cardWrapperSmall: {
    display: 'inline-flex',
    justifyContent: 'space-between',
  },
});
